import React from 'react';
import { WarningOutlined, CloseOutlined } from '@ant-design/icons';
import { Tooltip, Button } from 'antd';
import styles from './index.less';

const TIP_TEXT = 'The selected metric does not exist. Please remove it.';

export const DeletedMetric = () => (
  <Tooltip placement="top" title={TIP_TEXT}>
    <WarningOutlined className={styles.warnIcon} /> Deleted Metric
  </Tooltip>
);
export const DeletedMetricWithRemove = ({ onRemove }) => (
  <Tooltip placement="top" title={TIP_TEXT}>
    <span className={styles.deleteContainer}>
      <WarningOutlined className={styles.warnIcon} /> <span>Deleted Metric</span>
      <Button
        type="text"
        icon={<CloseOutlined />}
        className={styles.closeIcon}
        onClick={onRemove}
      />
    </span>
  </Tooltip>
);

export const DeletedMetricWithBorder = () => (
  <Tooltip placement="top" title={TIP_TEXT}>
    <span className={styles.container}>
      <WarningOutlined className={styles.warnIcon} /> Deleted Metric
    </span>
  </Tooltip>
);

export const DeletedMetricMessage = () => (
  <span className={styles.container}>
    <WarningOutlined className={styles.warnIcon} /> Some metrics or dimensions have been deleted and
    are not available to use anymore
  </span>
);
